import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'

import vueCustomElement from 'vue-custom-element'

Vue.config.productionTip = false

Vue.use(vueCustomElement);

(App as any).vuetify = vuetify;
(App as any).router = router
Vue.customElement('vue-maxcalendarapp', App)
